class BlogPostsList {

    constructor() {
        this.list = document.querySelector('.blog-posts-list__list');
        if (!this.list) return;

        this.paginationNumbers = document.querySelector('.js-blog-posts-list__pagination-numbers');
        this.btnPrev = document.querySelector('.js-blog-posts-list__pagination-btn-prev');
        this.btnNext = document.querySelector('.js-blog-posts-list__pagination-btn-next');
        this.catBtns = [...document.querySelectorAll('.blog-posts-list__cat-btn')];

        this.currentPage = 1;
        this.currentCat = 0;
        this.maxPages = 1;
        this.isLoading = false;

        this.init();
    }

    init() {
        this.setCategoryFromUrl();
        this.bindEvents();
        this.setActiveCategory(this.currentCat);
        this.fetchPosts(this.currentCat, 1);
    }

    setCategoryFromUrl() {
        const slug = new URLSearchParams(window.location.search).get('cat');
        if (!slug) return;
        const btn = this.catBtns.find(b => b.dataset.catSlug === slug);
        if (btn) this.currentCat = parseInt(btn.dataset.catId);
    }

    bindEvents() {

        this.catBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                if (this.isLoading) return;

                const catId = parseInt(btn.dataset.catId);
                if (catId === this.currentCat) return;

                this.currentCat = catId;
                this.currentPage = 1;

                this.updateUrl(btn.dataset.catSlug);
                this.setActiveCategory(catId);
                this.fetchPosts(catId, 1);
            });
        });

        this.btnPrev.addEventListener('click', () => {
            if (this.currentPage === 1) return;
            this.fetchPosts(this.currentCat, this.currentPage - 1);
        });

        this.btnNext.addEventListener('click', () => {
            if (this.currentPage === this.maxPages) return;
            this.fetchPosts(this.currentCat, this.currentPage + 1);
        });
    }

    updateUrl(slug) {
        history.replaceState(
            {},
            '',
            slug ? `${window.location.pathname}?cat=${slug}` : window.location.pathname
        );
    }

    setLoading(state) {
        this.isLoading = state;
        this.list.classList.toggle('blog-posts-list__list--loading', state);
    }

    setActiveCategory(catId) {
        this.catBtns.forEach(btn =>
            btn.classList.toggle('active', parseInt(btn.dataset.catId) === catId)
        );
    }

    fetchPosts(cat, page) {
        if (this.isLoading) return;

        this.setLoading(true);

        const url = new URL(blogPostsData.restUrl);

        if (cat) url.searchParams.set('cat_id', cat);
        url.searchParams.set('page', page);

        fetch(url)
            .then(r => r.json())
            .then(data => {

                this.list.innerHTML = data.html;

                this.currentPage = data.current_page;
                this.maxPages = data.max_pages;

                this.renderPagination();
                this.scrollToTop();

            })
            .finally(() => this.setLoading(false));
    }

    scrollToTop() {
        window.scrollTo({
            top: this.list.offsetTop - 120,
            behavior: 'smooth'
        });
    }

    renderPagination() {
        this.paginationNumbers.innerHTML = '';
        this.renderNumbers();
        this.updatePrevNextState();
    }

    updatePrevNextState() {
        this.btnPrev.classList.toggle('disabled', this.currentPage === 1);
        this.btnNext.classList.toggle('disabled', this.currentPage === this.maxPages);
    }

    renderNumbers() {

        const r = (p) => this.renderPage(p);

        if (this.maxPages <= 5) {
            for (let i = 1; i <= this.maxPages; i++) r(i);
            return;
        }

        if (this.currentPage <= 3) {
            r(1); r(2); r(3); r(4);
            this.renderDots();
            r(this.maxPages);
            return;
        }

        if (this.currentPage >= this.maxPages - 2) {
            r(1);
            this.renderDots();
            for (let i = this.maxPages - 3; i <= this.maxPages; i++) r(i);
            return;
        }

        r(1);
        this.renderDots();
        r(this.currentPage - 1);
        r(this.currentPage);
        r(this.currentPage + 1);
        this.renderDots();
        r(this.maxPages);
    }

    renderPage(page) {
        const btn = document.createElement('div');
        btn.className = 'blog-posts-list__pagination-number';
        btn.textContent = page;

        if (page === this.currentPage) btn.classList.add('active');

        btn.addEventListener('click', () => {
            if (page === this.currentPage) return;
            this.fetchPosts(this.currentCat, page);
        });

        this.paginationNumbers.appendChild(btn);
    }

    renderDots() {
        const dots = document.createElement('div');
        dots.className = 'pagination-dots';
        dots.textContent = '...';
        this.paginationNumbers.appendChild(dots);
    }
}

new BlogPostsList();